/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useOrgId } from '@jira/router-resources__navigation-organization-id/src/useOrgId.tsx';
import { GLOBAL_APP_MENU_ID } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';

export const useShortcutFallbackUrls = (): {
	'jira.sidebar.globalApp.confluence': string;
	'jira.sidebar.globalApp.loom': string;
	'jira.sidebar.globalApp.assets': string;
	'jira.sidebar.globalApp.opsgenie': string;
	// Shortcuts to Townsquare apps are based on how Townsquare constructs the fallback URLs in its nav implementation
	// @see townsquare/apps/home/src/sidebar/use-side-nav-app-items-for-nav-platform.tsx
	'jira.sidebar.globalApp.goals': string;
	'jira.sidebar.globalApp.projects': string;
	'jira.sidebar.globalApp.teams': string;
} => {
	const { data: orgId } = useOrgId();

	// Note: At the time of writing, an empty fallback URL will cause the shortcut
	// to be shown in the customization modal but not in the sidebar, if the URL is not populated elsewhere.
	return {
		[GLOBAL_APP_MENU_ID.GLOBAL_APP_CONFLUENCE]: '/wiki',
		[GLOBAL_APP_MENU_ID.GLOBAL_APP_LOOM]: 'https://www.loom.com',
		[GLOBAL_APP_MENU_ID.GLOBAL_APP_ASSETS]: '/jira/assets',
		[GLOBAL_APP_MENU_ID.GLOBAL_APP_OPSGENIE]: '',
		// Shortcuts to Townsquare apps are based on how Townsquare constructs the fallback URLs in its nav implementation
		// @see townsquare/apps/home/src/sidebar/use-side-nav-app-items-for-nav-platform.tsx
		[GLOBAL_APP_MENU_ID.GLOBAL_APP_GOALS]: orgId ? `/o/${orgId}/goals` : '/goals',
		[GLOBAL_APP_MENU_ID.GLOBAL_APP_PROJECTS]: orgId ? `/o/${orgId}/projects` : '/projects',
		[GLOBAL_APP_MENU_ID.GLOBAL_APP_TEAMS]: orgId ? `/o/${orgId}/people` : '/people',
	};
};
